// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-on-your-services-module__title[data-v-7ebbd2e0]{font-weight:900;font-size:28px;line-height:32px;color:#fff;margin-block-end:14px;display:flex;justify-content:space-between;align-items:center}.new-on-your-services-module__title a[data-v-7ebbd2e0]{font-weight:400;font-size:18px;line-height:22px}@media(max-width:767px){.new-on-your-services-module__title a[data-v-7ebbd2e0]{font-size:16px;line-height:18px;text-align:center}}", ""]);
// Exports
module.exports = exports;
